import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';

import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { refreshDeductibleOptionsAtom } from '../atoms/refreshDeductibleOptionsAtom';

interface GetPRCCurrentDeductibleType {
    getPRCCurrentDeductibleValue: () => Promise<string>;
}

export const getPRCCurrentDeductibleValueSelector = selector<GetPRCCurrentDeductibleType>({
    key: 'getPRCCurrentDeductibleValueSelector',
    get: ({ get }) => {
        get(refreshDeductibleOptionsAtom);

        const { jobNumber, sessionId } = get(jobInfoAtom);
        const { fixedId, lobCode } = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        if (!jobNumber) throw new Error('Invalid jobId');
        if (!sessionId) throw new Error('Invalid sessionId');
        if (!lobCode) throw new Error('Invalid linePrefix');
        if (!fixedId) throw new Error('Invalid coverableFixedId');

        return {
            getPRCCurrentDeductibleValue: async () => {
                return await OnlineSalesUnauthenticated.getPRCCurrentDeductibleValue(
                    jobNumber,
                    lobCode,
                    fixedId,
                    sessionId,
                    !isLoggedOn
                );
            }
        };
    }
});
